import {z} from 'zod'

import {RangeSettings} from '../../common/types'
import {LoadSpacingForm, LoadSpacingScenario} from '../types'

import {ErrorCodes} from './errorCodes'
import {validateFieldRange} from './validateFieldRange'

export const validateSpacingOrFlowRate = (
  data: LoadSpacingForm,
  scenario: LoadSpacingScenario,
  spacingSettings: RangeSettings,
  flowRateSettings: RangeSettings,
  ctx: z.RefinementCtx
) => {
  if (!scenario.flowRate && data.spacingOrFlowRate?.type === 'flowRate') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['flowRate'],
      message: ErrorCodes.flowRate.notAllowed
    })
  }

  if (!scenario.loadSpace && data.spacingOrFlowRate?.type === 'loadSpace') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['loadSpace'],
      message: ErrorCodes.spacing.notAllowed
    })
  }

  if (scenario.flowRate || scenario.loadSpace) {
    if (!data.spacingOrFlowRate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['spacingOrFlowRate'],
        message: ErrorCodes.spacing.required
      })
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['spacingOrFlowRate'],
        message: ErrorCodes.flowRate.required
      })

      return
    }

    if (data.spacingOrFlowRate.type === 'loadSpace') {
      validateFieldRange(
        data.spacingOrFlowRate.loadSpace,
        spacingSettings,
        'loadSpace',
        'spacingOrFlowRate.spacing',
        ctx
      )
    } else {
      validateFieldRange(
        data.spacingOrFlowRate.flowRate,
        flowRateSettings,
        'flowRate',
        'spacingOrFlowRate.flowRate',
        ctx
      )
    }
  }
}
